const BoxShadowDefault = `box-shadow: 0 0.46875rem 2.1875rem rgb(0 0 0 / 3%), 0 0.9375rem 1.40625rem rgb(0 0 0 / 3%), 0 0.25rem 0.53125rem rgb(0 0 0 / 5%), 0 0.125rem 0.1875rem rgb(0 0 0 / 3%) !important;`;
const BoxShadowBtnFocus = `box-shadow: 0 0.125rem 0.625rem rgb(68 64 84 / 40%), 0 0.0625rem 0.125rem rgb(68 64 84 / 50%) !important;`;
const BoxShadowBtnFocusHover = `box-shadow: 0 0.125rem 0.625rem rgb(68 64 84 / 50%), 0 0.0625rem 0.125rem rgb(68 64 84 / 60%) !important;`;
const BoxShadowBlack = `box-shadow: 7px 0 60px rgb(0 0 0 / 5%);`;

export const AppShadows = {
  BoxShadowDefault,
  BoxShadowBtnFocus,
  BoxShadowBtnFocusHover,
  BoxShadowBlack,
};
